'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@v2/utils/cn';

const labelVariants = cva(
  ' text-xs md:text-base text-gray-500 md:text-gray-800 font-medium leading-none peer-disabled:cursor-not-allowed '
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
      isRequired?: boolean;
    }
>(({ className, isRequired, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn('relative', labelVariants(), className)}
    {...props}
  >
    {children}
    {isRequired && <span className="absolute text-primary-500">*</span>}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
